import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Gmap from "./Gmap";
import Select from "react-select";
import Slider from "@mui/material/Slider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import {
  availableTimesOptions,
  servicesOptions,
} from "../contants/data";
// ICONS
import { GrPowerReset } from "react-icons/gr";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";

const Filters = ({ onFilter, data, stateCategory, filters }) => {
  const [thunks, setThunks] = useState(null);
  const [showAdvFilter, setShowAdvFilter] = useState(false);
  const { isFilter } = useSelector((state) => state[stateCategory]);
  const dispatch = useDispatch();

  // GEOLOCATE
  const { lat, lng, radius } = useSelector(
    (state) => state[stateCategory].filters.location
  );

  // NEW LAT,LNG
  const [newLat, setNewLat] = useState("");
  const [newLng, setNewLng] = useState("");

  // PRICE
  const { min: priceMin, max: priceMax } = useSelector(
    (state) => state[stateCategory].filters.price_range
  );
  const [priceVal, setPriceVal] = useState([priceMin, priceMax]);
  const handlePriceChange = (event, newValue) => {
    setPriceVal(newValue);
    dispatch(thunks?.changePrice({ min: newValue[0], max: newValue[1] }));
  };

  // SERVICES CATEGORY
  const { servicesCategory } = useSelector((state) => state[stateCategory].filters);
  const [selectedServicesCategory, setSelectedServicesCategory] = useState([]);
  const handleServicesCategoryChange = (options) => {
    setSelectedServicesCategory(options ? options.map((option) => option.value) : []);
    dispatch(
      thunks?.changeServices(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  // AVAILABLE TIMES
  const { availableTimes } = useSelector((state) => state[stateCategory].filters);
  const [selectedAvailableTimes, setSelectedAvailableTimes] = useState([]);
  const handleAvailableTimesChange = (options) => {
    setSelectedAvailableTimes(options ? options.map((option) => option.value) : []);
    dispatch(
      thunks?.changeAvailableTimes(
        options ? options.map((option) => option.value) : []
      )
    );
  };

  useEffect(() => {
    const loadThunks = async () => {
      let importedThunks;
      if (stateCategory === "services") {
        importedThunks = await import("../store/slices/services");
      }

      setThunks(importedThunks);
    };

    loadThunks();
  }, [stateCategory]);

  if (!thunks) {
    return <div>Loading...</div>;
  }

  const handleSubmit = () => {
    let finalLat = "";
    let finalLng = "";
    if ((newLat != "") & (newLng != "")) {
      finalLat = newLat;
      finalLng = newLng;
      dispatch(thunks?.changeLocation({ lat: finalLat, lng: finalLng }));
    } else {
      finalLat = lat;
      finalLng = lng;
    }

    onFilter({
      finalLat,
      finalLng,
      radius,
      priceVal,
      servicesCategory,
      availableTimes
    });
    dispatch(thunks?.activateFilter(true));
    dispatch(thunks?.setSearchTerm(""));
    dispatch(thunks?.setSortBy("Closest to Me"));
    dispatch(thunks?.resetSortedData());
  };

  const updateLoc = (lat, lng) => {
    setNewLat(() => {
      return lat;
    });
    setNewLng(() => {
      return lng;
    });
  };

  const handleResetFilter = () => {
    window.location.reload();
  };

  return (
    <div className="sidebar hide-mobile">
      <Gmap onChangeLoc={updateLoc} data={data} />
      {filters.includes("Price") && (
        <div className="form-control-wrap">
          <label>Price</label>
          <Slider
            value={priceVal}
            onChange={handlePriceChange}
            valueLabelDisplay="auto"
            max={5000}
            step={1}
          />
          <div className="price-range-wrap">
            <span>${priceVal[0].toLocaleString("en-US")} - </span>
            <span>${priceVal[1].toLocaleString("en-US")}</span>
          </div>
        </div>
      )}
      {filters.includes('Service Category') && (
        <div className='form-control-wrap'>
          <label>Services Category</label>
          <Select
            isMulti
            options={servicesOptions}
            onChange={handleServicesCategoryChange}
            value={servicesOptions.filter((option) =>
              selectedServicesCategory.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}
      {filters.includes('Available Times') && (
        <div className='form-control-wrap'>
          <label>Available Times</label>
          <Select
            isMulti
            options={availableTimesOptions}
            onChange={handleAvailableTimesChange}
            value={availableTimesOptions.filter((option) =>
              selectedAvailableTimes.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}
      <button onClick={() => handleSubmit()} className="primary mb-10">
        Filter
      </button>
      <button
        onClick={() => handleResetFilter()}
        className="reset"
        disabled={!isFilter}
      >
        Reset Filter
      </button>
    </div>
  );
};

export default Filters;
